<script setup lang="ts">
import { CtIcon } from '@camelot/components'
import { SUPPORTED_LANGUAGES, SUPPORTED_LOCALES, useTranslations } from '~/composables/translate/translations'
import { useStepStore } from '~/stores/step'

const language = useTranslations().language
const open = ref(false)

function switchLanguage(lang: string) {
  if (language.value !== lang) {
    open.value = false
    useStepStore().reloadStepWith(lang)
  }
}
</script>

<template>
  <div class="relative flex justify-center items-center lg:justify-center">
    <button @click="open = !open">
      <span class="text-black-100 font-bold">{{ SUPPORTED_LANGUAGES[language] }}</span>
      <CtIcon v-show="open" name="chevron_up" data-testid="chevron-up-img" color="--ct-color-black-100" />
      <CtIcon v-show="!open" name="chevron_down" data-testid="chevron-down-img" color="--ct-color-black-100" />
    </button>
    <ul v-if="open" class="bg-white rounded-2xl absolute shadow-10 top-auto bottom-0 translate-y-[-32px] overflow-hidden">
      <li
        v-for="lang in SUPPORTED_LOCALES"
        :key="lang"
        :value="lang"
      >
        <button
          class="w-full px-16 py-4 hover:bg-black-10 hover:text-pitch"
          :class="language === lang ? '!bg-rebel-100 !text-white' : ''"
          @click="switchLanguage(lang)"
        >
          {{ SUPPORTED_LANGUAGES[lang] }}
        </button>
      </li>
    </ul>
  </div>
</template>
